/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiInterest } from '../models/jofi-interest';

@Injectable({
  providedIn: 'root',
})
export class JofiContentManagementInterestsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation interestsControllerFindAll
   */
  static readonly InterestsControllerFindAllPath = '/v1/content-management/interests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interestsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  interestsControllerFindAll$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiInterest>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementInterestsService.InterestsControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiInterest>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interestsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interestsControllerFindAll(params?: {
    context?: HttpContext
  }
): Observable<Array<JofiInterest>> {

    return this.interestsControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiInterest>>) => r.body as Array<JofiInterest>)
    );
  }

}
